// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"152":"ce40662b","812":"f275e893","825":"65399c13","915":"68b5f268"}[chunkId] + ".css";
};